"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-DuplicateCollections',
    isLoading: 'c-DuplicateCollections--IsLoading',
    content: 'c-DuplicateCollections__Content',
    menu: 'c-DuplicateCollections__Menu'
};
exports.Style = {
    [exports.CSS.isLoading]: {
        display: 'flex',
        'justify-content': 'center'
    },
    [exports.CSS.content]: {
        display: 'flex',
        'white-space': 'pre-line',
        'align-items': 'baseline',
        'justify-content': 'space-around'
    },
    [exports.CSS.menu]: {
        width: '600px',
        position: 'absolute',
        [`& .${menu_style_1.CSS.menu}`]: {
            right: 'auto',
            width: '100%'
        }
    }
};
//# sourceMappingURL=collection.insight.process.modal.style.js.map